import {RootAppRouteErrorInner} from '@github-ui/react-core/future/RouterErrorBoundary'
import {useRouteError} from '@github-ui/react-router'

import {useSubAppName} from '../hooks/use-sub-app-name'

// Delegates to the same response-error vs. generic branching, document-title handling, and failbot
// reporting that the app-root boundary (RootAppRouteErrorElement) uses — this route is the nearest
// ancestor for every repo sub-app route, so errors are caught here first instead of bubbling to the
// root, but should render/report identically. Only the sub-app name (and boundary attribution) differ.
export function RepoErrorBoundary() {
  const appName = useSubAppName()
  const routeError = useRouteError()

  return <RootAppRouteErrorInner routeError={routeError} appName={appName} boundaryName="RepoErrorBoundary" />
}
